import { YesNoField } from "components/fields/YesNoField";
import { FlexBlockRow } from "components/FlexShowLayout";
import React from "react";
import { TextField } from "react-admin";

export const ColdStorageShowSection = (props) => {
	return [
		<FlexBlockRow>
			<YesNoField source="is_photo_of_label" key="is_photo_of_label" />
			<YesNoField source="is_reefer" key="is_reefer" />
			<TextField source="container_number" key="container_number" />
			<TextField source="total_boxes" key="total_boxes" />
		</FlexBlockRow>,
	];
};
